exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mapPage{position:absolute;left:200px;overflow:hidden}@media only screen and (max-width: 900px){.mapPanelMobile{margin-top:50px !important;max-width:460px !important}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/pages/Map/style.scss
// module id = 6313
// module chunks = 0